// reducer.js
import {
  SET_VALUE_RESERVATION_EN_COURS,
  SET_STATUT_RESERVATION_EN_COURS,
  SET_ANNEE_RESERVATION_EN_COURS,
  SET_CURRENT_PAGE_RESERVATION_EN_COURS,
  SET_ORDER_RESERVATION_EN_COURS,
  SET_SORT_FIELD_RESERVATION_EN_COURS,
} from './actionsTypes';

const initialState = {
  value: '',
  statut: '',
  annee: '',
  currentPage: 1,
  order:'desc' ,
  sortField: 'creee_le',
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_VALUE_RESERVATION_EN_COURS:
      return {
        ...state,
        value: action.payload,
      };
    case SET_STATUT_RESERVATION_EN_COURS:
      return {
        ...state,
        statut: action.payload,
      };
    case SET_ANNEE_RESERVATION_EN_COURS:
      return {
        ...state,
        annee: action.payload,
      };
    case SET_CURRENT_PAGE_RESERVATION_EN_COURS:
      return {
        ...state,
        currentPage: action.payload,
      };
    case SET_ORDER_RESERVATION_EN_COURS:
      return {
        ...state,
        order: action.payload,
      };
    case SET_SORT_FIELD_RESERVATION_EN_COURS:
      return {
        ...state,
        sortField: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
